/**
 * Site-wide phone CTA. Two pieces:
 *  - <PhoneBar />: slim top strip on every page promoting unpublished fares.
 *  - <FloatingCallButton />: mobile-only floating call FAB.
 */
import { Phone } from "@phosphor-icons/react";

export const PHONE_DISPLAY = "+1 (888) 555-7873";
export const PHONE_TEL = "+18885557873";

export function PhoneBar() {
  return (
    <div className="bg-[#C29B62] text-[#0A0A0B] relative z-[60]" data-testid="phone-bar">
      <div className="px-4 md:px-12 lg:px-24 py-2 flex items-center justify-center md:justify-between gap-4">
        <p className="hidden md:block text-[11px] tracking-[0.22em] uppercase font-semibold">
          Unpublished fares, group rates &amp; complex itineraries — better when you talk to a person.
        </p>
        <a
          href={`tel:${PHONE_TEL}`}
          data-testid="phone-bar-call"
          className="flex items-center gap-2 text-xs md:text-sm font-semibold tracking-[0.16em] uppercase hover:underline"
        >
          <Phone size={14} weight="fill" /> Call {PHONE_DISPLAY}
        </a>
      </div>
    </div>
  );
}

export function FloatingCallButton() {
  return (
    <a
      href={`tel:${PHONE_TEL}`}
      data-testid="floating-call-btn"
      aria-label={`Call ${PHONE_DISPLAY}`}
      className="md:hidden fixed bottom-5 right-5 z-50 w-14 h-14 bg-[#C29B62] text-[#0A0A0B] rounded-full shadow-2xl flex items-center justify-center hover:scale-105 transition-transform"
    >
      <Phone size={22} weight="fill" />
    </a>
  );
}
